import { render, staticRenderFns } from "./MemberSummary.vue?vue&type=template&id=99083204&scoped=true"
import script from "./MemberSummary.vue?vue&type=script&lang=js"
export * from "./MemberSummary.vue?vue&type=script&lang=js"
import style0 from "./MemberSummary.vue?vue&type=style&index=0&id=99083204&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99083204",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99083204')) {
      api.createRecord('99083204', component.options)
    } else {
      api.reload('99083204', component.options)
    }
    module.hot.accept("./MemberSummary.vue?vue&type=template&id=99083204&scoped=true", function () {
      api.rerender('99083204', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/components/MemberSummary.vue"
export default component.exports